import { IAnimateEmojiProps } from "interfaces";
import Emoji from "../../../emoji/emoji";

const AnimatedEmoji = ({emojiCode, direction}: IAnimateEmojiProps) => {
    return (
        <div>
            <div
                className={`pl-absolute ${direction === "RIGHT" ? "pl-right-3" : "pl-left-3"} pl-w-max pl-h-max pl-cursor-auto pl-bottom-14 pl-px-2 pl-py-1 ${direction === "RIGHT" ? "pl-spray-fifth-line-emoji-right" : "pl-spray-fifth-line-emoji-left"}`}>
                <Emoji name={emojiCode} className="pl-w-[12px] pl-h-[12px] pl-cursor-auto"/>
            </div>
            <div
                className={`pl-absolute ${direction === "RIGHT" ? "pl-right-3" : "pl-left-3"} pl-w-max pl-h-max pl-cursor-auto pl-bottom-14 pl-px-2 pl-py-1 ${direction === "RIGHT" ? "pl-spray-forth-line-emoji-right" : "pl-spray-forth-line-emoji-left"}`}>
                <Emoji name={emojiCode} className="pl-w-[12px] pl-h-[12px] pl-cursor-auto"/>
            </div>
            <div
                className={`pl-absolute ${direction === "RIGHT" ? "pl-right-3" : "pl-left-3"} pl-w-max pl-h-max pl-cursor-auto pl-bottom-14 pl-px-2 pl-py-1 ${direction === "RIGHT" ? "pl-spray-third-line-emoji-right" : "pl-spray-third-line-emoji-left"}`}>
                <Emoji name={emojiCode} className="pl-w-[12px] pl-h-[12px] pl-cursor-auto"/>
            </div>
            <div
                className={`pl-absolute ${direction === "RIGHT" ? "pl-right-3" : "pl-left-3"} pl-w-max pl-h-max pl-cursor-auto pl-bottom-14 pl-px-2 pl-py-1 ${direction === "RIGHT" ? "pl-spray-second-line-emoji-right" : "pl-spray-second-line-emoji-left"}`}>
                <Emoji name={emojiCode} className="pl-w-[12px] pl-h-[12px] pl-cursor-auto"/>
            </div>
            <div
                className={`pl-absolute ${direction === "RIGHT" ? "pl-right-3" : "pl-left-3"} pl-w-max pl-h-max pl-cursor-auto pl-bottom-14 pl-px-2 pl-py-1 ${direction === "RIGHT" ? "pl-spray-first-line-emoji-right" : "pl-spray-first-line-emoji-left"}`}>
                <Emoji name={emojiCode} className="pl-w-[12px] pl-h-[12px] pl-cursor-auto"/>
            </div>
            <div
                className={`pl-absolute ${direction === "RIGHT" ? "pl-right-3" : "pl-left-3"} pl-w-max pl-h-max pl-cursor-auto pl-bottom-14 pl-px-2 pl-py-1 ${direction === "RIGHT" ? "pl-spray-zero-line-emoji-right" : "pl-spray-zero-line-emoji-left"}`}>
                <Emoji name={emojiCode} className="pl-w-[12px] pl-h-[12px] pl-cursor-auto"/>
            </div>
        </div>
    )
}

export default AnimatedEmoji;